import Image from "next/image"
import React, { ReactNode } from "react"
import { twMerge } from "tailwind-merge"

interface IProps {
    children: ReactNode
    title: string
    desc: string
    isLoading?: boolean
    layoutClassName?: string
    headerClassName?: string
}

const ListPageLayout = ({
    children,
    title,
    desc,
    isLoading,
    layoutClassName,
    headerClassName,
}: IProps) => {
    return (
        <div className={twMerge("flex flex-col py-28 layout", layoutClassName)}>
            <div className="flex items-end justify-between">
                <div className="flex flex-col gap-4">
                    {isLoading ? (
                        <>
                            <div className="h-8 w-[100px] animate-pulse rounded-full bg-[#F7F6FF] dark:bg-[#33276F] md:h-12 md:w-[200px]"></div>
                            <div className="h-5 w-[150px] animate-pulse rounded-full bg-[#F7F6FF] dark:bg-[#33276F] md:h-8 md:w-[250px]"></div>
                        </>
                    ) : (
                        <>
                            <h1
                                className={twMerge(
                                    "text-3xl font-bold capitalize text-primary-theme-400 dark:text-white md:text-6xl",
                                    headerClassName
                                )}>
                                {title}
                            </h1>
                            {/* <p className="relative text-base font-medium text-black dark:text-white md:text-lg">
                                {desc}
                            </p> */}
                        </>
                    )}
                </div>
                <Image
                    src={"/svg/v2/sparkle.png"}
                    alt="sparkle"
                    style={{
                        objectFit: "contain",
                    }}
                    width={180}
                    height={180}
                    className="hidden md:block"
                />
            </div>
            {children}
        </div>
    )
}

export default ListPageLayout
